import { useEffect } from 'react'

import { Layout } from '../../components'
import { BatchFileUploadPanel } from '../../components/panels'
import { DRAWER_KEYS } from '../../store/constants'

const BatchFilePage = () => {

    useEffect(() => {
        document.title = 'Consulta em Lote | LCD'
    }, [])

    return (
        <Layout selectedKey={DRAWER_KEYS.BATCH_FILE}>
            <BatchFileUploadPanel />
        </Layout>
    )
}

export default BatchFilePage
